import { Box, Typography } from "@material-ui/core";
import { CloudUpload } from "@material-ui/icons";
import CloudDoneIcon from '@mui/icons-material/CloudDone';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useEffect } from "react";
import styles from '../DropZone.module.scss';

type Props = {
    label: string,
    file: File, 
    error: string | null
};

const LabelAndErrorDropzone = ({label, file, error}: Props) => {

    useEffect(() => {
        console.log(error);
    },[error]);


    if(error) return( 
        <Box className={styles.boxLabel}>
            <WarningAmberIcon style={{fontSize: 30}} color="error"/>
            <Typography className={styles.messageError} variant="body2">{error}</Typography>
        </Box>
    );

    return (
        <Box className={styles.boxLabel}>
            {!file ? <CloudUpload style={{fontSize: 30}} /> : <CloudDoneIcon style={{fontSize: 30}} />} 
            <Typography className={styles.labelFile} variant="body2">{file ? file.name : label}</Typography>
        </Box>
    );
};

export default LabelAndErrorDropzone;